import { Button, Form, Space, theme } from 'antd';
import { FC, ReactNode } from 'react';
import { Regex, Type, TypeUnderline } from 'react-bootstrap-icons';

import { PageSearchAndReplaceFormInputs } from '@/modules/Pages';

interface ToggleButtonProps {
  value?: boolean;
  title: string;
  icon: ReactNode;
  onChange?: (value: boolean) => void;
}

const ToggleButton: FC<ToggleButtonProps> = ({ value, onChange, title, icon }) => {
  const { token } = theme.useToken();

  return (
    <Button
      type="text"
      size="small"
      title={title}
      icon={icon}
      onClick={() => onChange?.(!value)}
      style={{
        color: value ? token.colorPrimary : token.colorTextTertiary,
        backgroundColor: value ? token.colorPrimaryBg : 'transparent',
        border: `1px solid ${value ? token.colorPrimaryBorder : 'transparent'}`,
      }}
    />
  );
};

export const PagesSearchAndReplaceFormToggles: FC = () => (
  <Space size={2}>
    <Form.Item name={PageSearchAndReplaceFormInputs.MatchCase} noStyle>
      <ToggleButton title="Пошук за урахуванням регістру (Match Case)" icon={<Type />} />
    </Form.Item>
    <Form.Item name={PageSearchAndReplaceFormInputs.WholeWord} noStyle>
      <ToggleButton title="Пошук за цілим словом (Match Whole Word)" icon={<TypeUnderline />} />
    </Form.Item>
    <Form.Item name={PageSearchAndReplaceFormInputs.UseRegex} noStyle>
      <ToggleButton title="Пошук за регулярним виразом (Use Regular Expression)" icon={<Regex />} />
    </Form.Item>
  </Space>
);
